import { useState } from 'react'
import { Button } from '@w/ui/components/button'
import { Input } from '@w/ui/components/input'
import { Dialog, DialogTrigger, DialogPopup, DialogHeader, DialogTitle, DialogPanel, DialogFooter, DialogClose } from '@w/ui/components/dialog'
import { hexToOklch, oklchToHex } from '@w/ui/palette'
import { useTranslation } from '../i18n'

const suggestions = ['#dc2626', '#ea580c', '#ca8a04', '#16a34a', '#0891b2', '#2563eb', '#7c3aed', '#db2777']

export function SourceColorDialog({ value, onChange }: { value: string; onChange: (color: string) => void }) {
  const { t } = useTranslation('settings')
  const common = useTranslation('common').t
  const [draft, setDraft] = useState(value)
  const valid = /^#[\da-f]{6}$/i.test(draft)
  const color = hexToOklch(valid ? draft : value)
  return <Dialog onOpenChange={open => { if (open) setDraft(value) }}>
    <DialogTrigger render={<button type="button" className="size-8 shrink-0 cursor-pointer rounded-full border border-separator" style={{ backgroundColor: value }} aria-label={t('sourceHue')} data-testid="flashcards-source-hue" />} />
    <DialogPopup>
      <DialogHeader><DialogTitle>{t('setColor')}</DialogTitle></DialogHeader>
      <DialogPanel className="flex flex-col gap-5">
        <div className="h-16 rounded-lg" style={{ backgroundColor: valid ? draft : value }} />
        <div className="flex flex-wrap gap-3" aria-label={t('colorSuggestions')}>
          {suggestions.map(suggestion => <button key={suggestion} type="button" className="size-8 rounded-full border border-separator" style={{ backgroundColor: suggestion }} aria-label={suggestion} aria-pressed={draft.toLowerCase() === suggestion} onClick={() => { setDraft(suggestion) }} />)}
        </div>
        <label className="flex flex-col gap-2">{t('sourceHue')}
          <input type="range" min="0" max="360" value={color.h} onChange={event => { setDraft(oklchToHex({ l: 0.6, c: 0.18, h: Number(event.target.value) })) }} />
        </label>
        <label className="flex flex-col gap-2" htmlFor="flashcards-source-color-hex">Hex
          <Input id="flashcards-source-color-hex" data-testid="flashcards-source-color-hex" value={draft} aria-invalid={!valid} maxLength={7} onChange={event => { setDraft(event.target.value) }} />
        </label>
      </DialogPanel>
      <DialogFooter>
        <DialogClose render={<Button variant="outlined" />}>{common('cancel')}</DialogClose>
        <DialogClose render={<Button data-testid="flashcards-set-color" disabled={!valid} onClick={() => { onChange(draft) }} />}>{t('setColor')}</DialogClose>
      </DialogFooter>
    </DialogPopup>
  </Dialog>
}
